import React from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Skills from "@/components/Skills";
import Experience from "@/components/Experience";
import Projects from "@/components/Projects";
import Certifications from "@/components/Certifications";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
    return (
        <div
            data-testid="app-root"
            className="min-h-screen bg-bg-base text-ink-primary font-mono antialiased selection:bg-term-green selection:text-bg-base"
        >
            <Navbar />
            <main>
                <Hero />
                <About />
                <Skills />
                <Experience />
                <Projects />
                <Certifications />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
